export const Data = {
    "外链地址":"Outer chain address",
    "资料标题":"Material title",
    "引用自":"Quoted from:",
    "允许视频倍速":"Allow video playback at multiple speeds",
    "不允许视频倍速播放":"Don't allow video playback at multiple speeds",
    "允许进度条拖拽":"Allow progress bar dragging",
    "不允许进度条拖拽":"Don't allow progress bar dragging",
    "允许跳过互动答题":"Allow to skip interactive answers",
    "添加外链素材":"Add external chain material",
    "预览":"Preview",
    "逻辑错误":"Logic error",
    "上传中当前进度":"Uploading, current progress:",
    "外链资源":"External chain resources",
    "截至时间":"Deadline:",
    "时长":"Duration",
    "需回复":"Need to reply",
    "人已读":"Read",
    "人已参与":"Participated",
    "直播参与人数":"Number of live participants",
    "平均在线时长":"Average online duration",
    "完成回顾学习人数":"Number of people who have completed review",
    "最后访问时间":"Last access time:",
    "查阅":"Consult",
    "学习总时长":"Total duration",
    "学习进度":"Progress",
    "互动答题完成度":"Interactive answer completion",
    "直播在线":"Live online",
    "点我发弹幕":"Send bullet screen...",
    "发送弹幕/评论":"Send bullet screen/comment",
    "很抱歉该视频被老师设置成不对外开放暂时无法预览":"Sorry, this video is set to be closed by the teacher and cannot be previewed temporarily",
    "当前老师设置为不允许跳过互动答题":"Teacher is not allowed to skip interactive answers",
    "前往答题":"Answer the question",
    "当前老师设置为允许跳过互动答题":"Teacher allow skipping interactive answers",
    "跳过答题":"Skip Answer",
    "作答保存成功":"Answer saved successfully",
    "主画面":"Main screen",
    "批阅互动":"Correct interaction",
    "个视频资源":"video resources",
    "资源类型":"Resource Type",
}